// Logica de cliente del correo de onboarding. El resto (builder de HTML) vive
// en la Edge Function (Deno); el cliente NO puede importarla (ModuleScopePlugin).
//
// Solo se envia a personas de un club: fundadores y staff (org_id no nulo). NO a
// platform admins (org_id null, is_platform_admin), que no son staff de ningun
// club — la bienvenida "Te uniste a tu club" no les aplica.
export const shouldSendWelcome = (staff) =>
  !!staff &&
  !staff.welcome_email_sent_at &&
  !staff.is_platform_admin &&
  !!staff.org_id
